import { render, staticRenderFns } from "./returnedReasonModal.vue?vue&type=template&id=b063b16e&scoped=true"
import script from "./returnedReasonModal.vue?vue&type=script&lang=js"
export * from "./returnedReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b063b16e",
  null
  
)

export default component.exports